import * as actionTypes from '../../../constants/actionTypes';
import IntlMessages from '../../../util/IntlMessages';
import * as constants from '../../../constants';
import * as infoApi from '../../../api/info';
import * as db from '../../../util/db';
import * as common from '../common';
import * as field from '../field';

export const operatorProfileAction = () => async (dispatch, getState) => {
  let currentState = getState();
  let vMobileNumber = currentState.config.mobile;
  let profile = currentState.field.profile;
 // if (profile.vFirstname === '') {
    let result = await infoApi.operatorProfile({
      vMobileNumber,
      eProfileType: 'HomePage',
    });

    if (result.status)
      dispatch(field.setFields([{ data: result.data[0], field: 'profile' }]));
  //  }
};

export const applicationConfigAction = () => async () => {
  let result = await infoApi.applicationConfig({ iPersonType: constants.PERSON_TYPE });
  if (result.status && result.data[0].length !== 0) {
    let data = result.data[0];
    db.createMapConfig(data.vMapType);
  }
};

export const operatorUpdateOnlineAction = () => async (dispatch, getState) => {
  let currentState = getState();
  let data = {
    vMobileNumber: currentState.config.mobile,
    iOnlineStatus: currentState.field.profile.iOnlineStatus === 1 ? 0 : 1,
  };
  let result = await infoApi.operatorUpdateOnline(data);
  if (result.status) {
    let newProfile = currentState.field.profile;
    newProfile.iOnlineStatus = data.iOnlineStatus;
    dispatch(field.setFields([{ data: newProfile, field: 'profile' }]));
  }
};

export const operatorUpdatePasswordAction = () => async (dispatch, getState) => {
  dispatch({ type: actionTypes.LOADING_BTN, payload: true });
  let currentState = getState();
  let data = {
    vPassword: currentState.field.password,
    vMobileNumber: currentState.config.mobile,
    repeatPassword: currentState.field.repeatPassword,
  };
  if (validateUpdatePassword(data)) {
    let result = await infoApi.operatorUpdatePassword(data);
    if (result.status) {
      dispatch(common.snackbarAction(true, result.message));
      dispatch(
        field.setFields([
          { data: '', field: 'password' },
          { data: '', field: 'repeatPassword' },
        ]),
      );
    }
  } else
    dispatch(
      common.snackbarAction(true, <IntlMessages id="passwordEnteredIsIncorrect" />),
    );
  dispatch({ type: actionTypes.LOADING_BTN, payload: false });
};

export const getSupportNumberAction = () => async (dispatch, getState) => {
  let currentState = getState();
  if (currentState.field.supportNumber === '') {
    let result = await infoApi.getSupportNumber({ iPersonType: constants.PERSON_TYPE });
    if (result.status)
      dispatch(
        field.setFields([
          { data: result.data[0].vSupportNumber, field: 'supportNumber' },
        ]),
      );
  }
};

export const getReasonSupportAction = () => async (dispatch) => {
  let result = await infoApi.getReasonSupport();
  if (result.status) {
    dispatch(
      field.setFields([
        {
          data: result.data.filter((item) => item.iPersonType === constants.PERSON_TYPE),
          field: 'reasonSupport',
        },
      ]),
    );
  }
};

export const newSupportAction =
  ({ comment: vComment, subject: vReasonSupportTitle }) =>
  async (dispatch, getState) => {
    dispatch(common.loadingBtnAction(true));
    await dispatch(operatorProfileAction());

    let currentState = getState();
    const vMobileNumber = currentState.config.mobile;
    const vFullName =
      currentState.field.profile.vFirstname + ' ' + currentState.field.profile.vLastname;
    const data = {
      vFullName,
      vMobileNumber,
      vComment,
      vReasonSupportTitle,
      iPersonType: constants.PERSON_TYPE,
    };

    const result = await infoApi.supportRequest(data);

    dispatch(common.snackbarAction(true, result.message));
    dispatch(common.loadingBtnAction(false));
    return true;
  };

const validateUpdatePassword = (data) => {
  if (
    data.vPassword !== '' &&
    data.repeatPassword !== '' &&
    data.vPassword.length >= 6 &&
    data.vPassword === data.repeatPassword
  )
    return true;
  return false;
};
